import { gql } from "@apollo/client";

export const REGISTER_DEVICE = gql`
  mutation RegisterDevice($input: RegisterDeviceInput!) {
    result: registerDevice(input: $input) {
      success
    }
  }
`;
